import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ripple from 'vuetify/lib/directives/ripple'
import { colors } from 'vuetify/lib'

Vue.use(Vuetify, { directives: { ripple } })

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },

  icons: {
    values: { expand: 'mdi-menu-down' },
  },

  theme: {
    themes: {
      light: {
        primary: colors.teal.lighten1,
        secondary: colors.purple.base,
        accent: colors.pink.base,
        info: colors.blue.base,
        success: colors.green.base,
        warning: colors.amber.darken2,
        error: colors.red.base,

        primaryVariant: colors.teal.lighten5,
        errorVariant: colors.red.lighten5,

        // Cores personalizadas para light mode
        primaryLighten: colors.teal.lighten5,
        warningLighten: colors.amber.lighten5, // Mais claro para light mode
        infoLighten: colors.blue.lighten5, // Mais claro para light mode
      },

      dark: {
        primary: colors.teal.lighten1,
        secondary: colors.purple.base,
        accent: colors.pink.base,
        info: colors.blue.base,
        success: colors.green.base,
        warning: colors.amber.darken2,
        error: colors.red.base,

        primaryVariant: colors.teal.darken4,
        errorVariant: colors.red.darken4,

        // Cores personalizadas para dark mode
        primaryLighten: colors.teal.darken3,
        warningLighten: colors.amber.darken3,
        infoLighten: colors.blue.darken3,
      },
    },
  },
})
